import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMatchTextImageToTextBottom({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [choices, setChoices] = useState({});
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);
    const [choiceStyle, setChoiceStyle] = useState(data.choiceStyle ?? {});
    const [answerBoxStyle, setAnswerBoxStyle] = useState(data.answerBoxStyle ?? {});

    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );

    const [answerBox, setAnswerBox] = useState(data.answerBox);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setChoices({});
        setSelectedChoice(null);
        setSelectedKeyPrevious(null);
        setChoiceStyle(data.choiceStyle ?? {});
        setAnswerBoxStyle(data.answerBoxStyle ?? {});
        setAvailableChoices(makeArrayRandom(data.choices));
        setAnswerBox(data.answerBox);
    }, [question,
        data.choiceStyle,
        data.answerBoxStyle,
        data.choices,
        data.answerBox,
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (choices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === choices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== choices[index]?.value)) {
            let currentChoices = {...choices};
            const previousChoice = choices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentChoices = {
                ...currentChoices,
                [index]: {
                    value: selectedChoice.value,
                },
            }
            setChoices(currentChoices);

            if (
                typeof questionData.answer.value === "object" &&
                !Array.isArray(questionData.answer.value)
            ) {
                const answerKeys = Object.keys(questionData.answer.value);

                const formattedAnswer = answerKeys.reduce(
                    (acc, key, keyIndex) => {
                        acc[key] = currentChoices[key]?.value || null;
                        return acc;
                    },
                    {}
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: formattedAnswer,
                });
            } else {
                const updatedAnswer = Object.values(currentChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
        }
    };

    const handleRemoveChoice = (index) => {
        const removedChoice = choices[index];
        
        if (removedChoice) {
            setChoices((prevChoices) => {
                const newChoices = { ...prevChoices };
                delete newChoices[index];

                if (
                    typeof questionData.answer.value === "object" &&
                    !Array.isArray(questionData.answer.value)
                ) {
                    const answerKeys = Object.keys(
                        questionData.answer.value
                    );

                    let canProceed = false;
                    const formattedAnswer = answerKeys.reduce(
                        (acc, key, keyIndex) => {
                            acc[key] = newChoices[key]?.value || null;
                            if (acc[key] !== null && acc[key] !== "") {
                                canProceed = true;
                            }
                            return acc;
                        },
                        {}
                    );

                    onAnswer({
                        canProceed,
                        answer: formattedAnswer,
                    });
                } else {
                    const updatedAnswer = Object.values(newChoices).map(
                        (choice) => choice.value
                    );

                    // set to false so that next button will be disabled
                    const canProceed = false;
                    onAnswer({
                        canProceed,
                        answer: updatedAnswer,
                    });
                }

                return newChoices;
            });

            setAvailableChoices((prevChoices) => [
                ...prevChoices,
                {
                    value: removedChoice.value,
                },
            ]);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                textAlign: "center"
            }}
        >
            {/* For Choices */}
            <Box sx={{
                position: "relative",
                height: "150px",
                width: choiceStyle?.width ?? "700px",
                marginBottom: "10px",
                border: "1px dashed lightgrey",
                textAlign: "center",
            }}>
                <Box sx={{
                    boxSizing: "border-box",
                    width: "100%",
                    height: "100%",
                    display: "grid",
                    gridTemplateColumns: choiceStyle?.gridTemplateColumns ?? "repeat(4, 1fr)",
                    justifyItems: "center",
                    gap: "10px",
                    padding: "10px",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    textAlign: "center",
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index}
                            sx={{
                                borderBottom: "10px solid rgb(52, 148, 186)",
                                position: "relative",
                                lineHeight: "1em",
                                fontWeight: "bold",
                                fontSize: "20px",
                                height: "42px",
                                width: "147px",
                                display: "inline-block",
                                boxSizing: "content-box",
                                backgroundColor: "#aad6e7",
                                padding: "4px",
                                textAlign: "center",
                                boxShadow:
                                selectedChoice?.value === choice.value
                                    ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                    : "none",
                            }}
                            onClick={() => { handleChoiceClick(choice) }}
                            disabled={selectedChoice === choice}
                        >
                            <Box 
                                sx={{
                                    display: "inline-flex",
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    userSelect: "none",
                                    pointerEvents: "none",
                                    fontSize: "18px",
                                    lineHeight: "1em",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}
                            >{choice.value}</Box>
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* For Answer */}
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "55px",
                width: "830px",
            }}>
                {answerBox.map((answer, index) => (
                    <Box 
                        key={index}
                        sx={{
                            backgroundColor: choiceStyle && choiceStyle.backgroundColor,
                            borderBottom: choiceStyle && choiceStyle.borderBottom,
                            padding: "0px",
                            width: answerBoxStyle?.width ?? "200px",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "55px"
                        }}
                    >
                        <Box sx={{
                            fontWeight: "bold",
                            fontSize: "30px",
                            textAlign: "center",
                        }}>{answer.headerText}</Box>
                        <Box component="img" src={`${imagesResources}${answer.image}`} alt="Img" sx={{marginTop: "8px"}}/>
                        <Box 
                            sx={{
                                height: "50px",
                                width: "155px",
                                marginTop: "10px",
                                position: "relative",
                                display: "inline-block",
                                boxSizing: "border-box",
                                padding: "4px",
                                lineHeight: "0.8em",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontSize: "55px",
                                boxShadow:
                                        selectedChoice
                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                            : "none",
                                backgroundColor: choices[answer.stateKey]
                                        ? "#aad6e7"
                                        : "white",
                                borderTop: choices[answer.stateKey]
                                        ? "none"
                                        : choiceStyle && choiceStyle.borderTop,
                            }}
                            onClick={() => handleChoiceAssign(answer.stateKey)}
                        >
                            {choices[answer.stateKey] ? (
                            <Box
                                sx={{
                                    top: "initial",
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    lineHeight: "0.8em",
                                    fontWeight: "bold",
                                    fontSize: "55px",
                                    textAlign: "center"
                                }}
                            >
                                <Box sx={{
                                    position: "relative",
                                    lineHeight: "1em",
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    height: "42px",
                                    width: "147px",
                                    display: "inline-block",
                                    boxSizing: "content-box",
                                    backgroundColor: "#aad6e7",
                                    padding: "4px",
                                    textAlign: "center",
                                }}>
                                    <Box sx={{
                                        display: "inline-flex",
                                        width: "100%",
                                        height: "100%",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        userSelect: "none",
                                        pointerEvents: "none",
                                        fontSize: "18px",
                                        lineHeight: "1em",
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    }}>{choices[answer.stateKey].value}</Box>
                                </Box>
                                {/* Close  */}
                                <Box
                                    className="selected-close-btn"
                                    sx={{
                                        right: "0px",
                                        top: "8px",
                                        display: "content-box",
                                        lineHeight: "0.8em",
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveChoice(answer.stateKey);
                                    }}
                                >X</Box>
                            </Box>
                                ) :
                                <span></span>
                            }
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};